import React, { useState, useEffect } from 'react';

interface SvgIconProps {
  name: string;
  color?: string;
  size?: number;
  className?: string;
}

// Loaded SVG icons cache
const loadedIcons: { [key: string]: string } = {};

// SVG Icon component
export const SvgIcon: React.FC<SvgIconProps> = ({ name, color = 'currentColor', size = 24, className = '' }) => {
  const [svgContent, setSvgContent] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const loadIcon = async () => {
      // Use cached icon if already loaded
      if (loadedIcons[name]) {
        setSvgContent(loadedIcons[name]);
        setLoading(false);
        return;
      }

      try {
        // Try to load the icon from /public/icons
        const response = await fetch(`/icons/${name}.svg`);
        
        if (!response.ok) {
          throw new Error(`Cannot load icon ${name}`);
        }
        
        const svgText = await response.text();
        
        // Store the icon in cache
        loadedIcons[name] = svgText;
        setSvgContent(svgText);
        setLoading(false);
      } catch (err) {
        setError(true);
        setLoading(false);
      }
    };

    loadIcon();
  }, [name]);

  if (loading) {
    // Placeholder while loading
    return (
      <div className={`svg-icon ${className}`}>
        <div style={{ backgroundColor: 'rgba(0,0,0,0.1)' }}></div>
      </div>
    );
  }

  if (error || !svgContent) {
    return null;
  }

  // Apply styles to the SVG container
  const containerStyle = {
    color: color,
    display: 'flex'
  };

  // Render SVG content directly
  return (
    <div 
      className={`svg-icon ${className}`}
      style={containerStyle}
      dangerouslySetInnerHTML={{ __html: svgContent }}
    />
  );
};

export default SvgIcon; 